/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { OrganizationWorkplaceDetail } from './organizationWorkplaceDetail';

/**
 * Serializer for organization workplaces list for directors.
 */
export interface OrganizationWorkplaces { 
    organizationId: string;
    organizationName: string;
    readonly workplaces: Array<OrganizationWorkplaceDetail>;
    totalWorkplaces: number;
    currentWorkplaceId: number;
}